// Stringhe UI di default (italiano) per MenuView e AICliente
export const defaultUIStrings = {
  loading: "Caricamento...",
  allergens: "Allergeni",
  placeholder: "Es. senza cipolla",
  add: "Aggiungi",
  callService: "Chiama servizio",
  orderSummary: "Riepilogo ordini",
  sendOrder: "Invia ordine",
  send: "Invia",
  sent: "Inviati",
  remove: "Rimuovi",
  close: "Chiudi",
  notesPlaceholder: "Note aggiuntive...",
  sentOrders: "Ordini inviati",
  aiAssistantTitle: "Assistente AI",
  aiPostOrderTitle: "Consiglio dallo Chef AI",
  aiPostOrderClose: "Ho capito",
  itemAdded: "Piatto aggiunto al carrello",
  orderSent: "Ordine inviato alla cucina",
  waiterCalled: "Il cameriere è stato chiamato",
  noOrderSent: "Nessun ordine inviato.",
  noDishSelected: "Nessun piatto selezionato",
  noDishAdded: "Nessun piatto aggiunto.",
  callError: "Errore durante la chiamata",
  sessionExpired: "Sessione scaduta. Scansiona di nuovo il QR code.",
  menuLoadError: "Errore nel caricamento del menu",
  
  // AICliente - Header
  aiHelperSubtitle: "Ti aiuto a scegliere",
  aiPreparingAdvice: "Sto preparando consigli personalizzati…",
  
  // AICliente - Domande rapide
  aiHowDoYouFeel: "Come ti senti?",
  aiLightTitle: "Qualcosa di leggero",
  aiLightSubtitle: "Piatti freschi e non pesanti",
  aiHungryTitle: "Ho molta fame",
  aiHungrySubtitle: "Piatti abbondanti e soddisfacenti",
  aiSpecialTitle: "Serata speciale",
  aiSpecialSubtitle: "Piatti d'effetto",
  aiHappyTitle: "Felice",
  aiHappySubtitle: "Qualcosa che mi renda ancora più felice",
  aiStressedTitle: "Stressato",
  aiStressedSubtitle: "Ho bisogno di rilassarmi",
  aiSadTitle: "Triste",
  aiSadSubtitle: "Ho bisogno di conforto",
  aiAngryTitle: "Arrabbiato",
  aiAngrySubtitle: "Qualcosa con carattere",
  aiCuriousTitle: "Curioso",
  aiCuriousSubtitle: "Sorprendimi",
  
  // AICliente - Caricamento e azioni
  aiSearchingDishes: "Sto cercando i piatti migliori…",
  aiPairingsFor: "Abbinamenti per:",
  aiLoadingPairings: "Carico abbinamenti…",
  aiSuggestPairings: "Suggerisci abbinamenti",
  aiSelectDish: "Seleziona un piatto",
  aiChangeDish: "Cambia piatto",
  
  // AICliente - Errori
  aiQuickAdviceError: "Errore durante i consigli rapidi.",
  aiPairingsError: "Errore durante abbinamenti.",
  
  // Popup suggerimenti
  suggestionPopupTitle: "Vuoi dei suggerimenti?",
  suggestionPopupText: "L'AI può consigliarti altri piatti che si abbinano bene con",
  suggestionYes: "Sì, mostrami",
  suggestionNo: "No, grazie",
  suggestionLoading: "Cerco abbinamenti perfetti...",
  suggestionTitle: "Ti consiglio anche:"
};
